var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2374 9.26531V4.32805C24.2374 2.79468 23.5414 2.1748 21.8123 2.1748H17.4188C15.6897 2.1748 14.9937 2.79468 14.9937 4.32805V9.25443C14.9937 10.7987 15.6897 11.4077 17.4188 11.4077H21.8123C23.5414 11.4186 24.2374 10.7987 24.2374 9.26531Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2374 21.4998V17.1063C24.2374 15.3772 23.5414 14.6812 21.8123 14.6812H17.4188C15.6897 14.6812 14.9937 15.3772 14.9937 17.1063V21.4998C14.9937 23.2289 15.6897 23.9249 17.4188 23.9249H21.8123C23.5414 23.9249 24.2374 23.2289 24.2374 21.4998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7311 9.26531V4.32805C11.7311 2.79468 11.0351 2.1748 9.30593 2.1748H4.91243C3.1833 2.1748 2.4873 2.79468 2.4873 4.32805V9.25443C2.4873 10.7987 3.1833 11.4077 4.91243 11.4077H9.30593C11.0351 11.4186 11.7311 10.7987 11.7311 9.26531Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7311 21.4998V17.1063C11.7311 15.3772 11.0351 14.6812 9.30593 14.6812H4.91243C3.1833 14.6812 2.4873 15.3772 2.4873 17.1063V21.4998C2.4873 23.2289 3.1833 23.9249 4.91243 23.9249H9.30593C11.0351 23.9249 11.7311 23.2289 11.7311 21.4998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dash-icon.fffbf9bfd61f945a0935eacdb871ff88.svg";
export { ForwardRef as ReactComponent };